module.exports = __webpack_public_path__ + "img/csm_Ersa-HOTFLOW-THREE-900x675-02_36ea151c27.a8976639.png";